import React from 'react';
import {Helmet} from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import photoEditorHeader from './photo-editor-header.md';
import photoEditorSectionOne from './photo-editor-section-one.md';
import photoEditorSectionTwo from './photo-editor-section-two.md';
import photoEditorSectionThree from './photo-editor-section-three.md';
import photoEditorSectionFour from './photo-editor-section-four.md';
import photoEditorHowToHeader from './photo-editor-how-to-header.md';
import photoEditorHowToStepOne from './photo-editor-how-to-step-one.md';
import photoEditorHowToStepTwo from './photo-editor-how-to-step-two.md';
import photoEditorHowToStepThree from './photo-editor-how-to-step-three.md';
import photoEditorHowToStepFour from './photo-editor-how-to-step-four.md';

import {Features} from '../..';

import image1 from './assets/photo-editor-page-1.jpg';
import image2 from './assets/photo-editor-page-2.jpg';
import image3 from './assets/photo-editor-page-3.jpg';
import image4 from './assets/photo-editor-page-4.jpg';

import styles from '../styles';

const PhotoEditor = () => (
  <Features customMasthead={photoEditorHeader}>
    <Helmet>
      <title>Simple online image editor to edit photos | ImageResize.org</title>
      <meta
        name="description"
        content="Easily edit images online for free. Apply image effects, crop, rotate or flip images to fit your needs."
      />
    </Helmet>
    <div className='container'>
      <div className='twoSections verticallyCentered content'>
        <ReactMarkdown className='section' source={photoEditorSectionOne} />
        <div className='section'>
          <img className={styles.featureImage} src={image1} alt="" />
        </div>
      </div>
    </div>
    <div className='darkSection'>
      <div className='twoSections verticallyCentered container'>
        <div className='section'>
          <img className={styles.featureImage} src={image2} alt="" />
        </div>
        <ReactMarkdown className='section' source={photoEditorSectionTwo} />
      </div>
    </div>
    <div className='twoSections verticallyCentered container'>
      <ReactMarkdown className='section' source={photoEditorSectionThree} />
      <div className='section'>
        <img className={styles.featureImage} src={image3} alt="" />
      </div>
    </div>
    <div className='darkSection'>
      <div className='twoSections verticallyCentered container'>
        <div className='section'>
          <img className={styles.featureImage} src={image4} alt="" />
        </div>
        <ReactMarkdown className='section' source={photoEditorSectionFour} />
      </div>
    </div>
    <div className='container'>
      <ReactMarkdown className='section center' source={photoEditorHowToHeader} />
    </div>
    <div className={styles.howToGrid}>
      <div className={styles.howToItem}>
        <div className={styles.step}>01</div>
        <ReactMarkdown source={photoEditorHowToStepOne} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>02</div>
        <ReactMarkdown source={photoEditorHowToStepTwo} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>03</div>
        <ReactMarkdown source={photoEditorHowToStepThree} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>04</div>
        <ReactMarkdown source={photoEditorHowToStepFour} />
      </div>
    </div>
  </Features>
);

export default PhotoEditor;



// WEBPACK FOOTER //
// ./src/containers/Features/PhotoEditor/index.jsx